export default __webpack_public_path__ + "static/media/trash.325048a7.svg";